export function childrenToString(children:React.ReactNode) {
  return typeof children == 'string' ? children : '';
}